import { defineComponent as n, createBlock as a, openBlock as r, unref as l, mergeProps as p, withCtx as c, createElementVNode as m } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const v = /* @__PURE__ */ n({
  name: "IconPackage",
  __name: "IconPackage",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (d, e) => (r(), a(l(i), p(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M3.5 4.25A1.25 1.25 0 0 0 2.25 5.5v13a1.25 1.25 0 0 0 1.25 1.25h17a1.25 1.25 0 0 0 1.25-1.25v-13a1.25 1.25 0 0 0-1.25-1.25h-17m.25 14V5.75H10v5.765a.3.3 0 0 0 .434.268l1.432-.716a.3.3 0 0 1 .268 0l1.432.716A.3.3 0 0 0 14 11.515V5.75h6.25v12.5H3.75",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
